// extracted by mini-css-extract-plugin
module.exports = {"cell":"SettingsRole__cell","showMore":"SettingsRole__show-more","wrapper":"SettingsRole__wrapper","settingItem":"SettingsRole__setting-item"};